import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureDeveloperEnabled } from '@/features/developers/guard.js';
import { useUiStore } from '@/features/settings/ui-store.js';

/**
 * `/developers/:id` — the section lives at `/developer` (singular), scoped by the sidebar workspace
 * switcher. A developer is its own workspace (`developer.id === workspace.id`), so this selects that
 * workspace before redirecting, which is what makes it a link to one developer: the connection alert
 * a contact person gets in Teams points here.
 */
export const Route = createFileRoute('/developers/$id')({
  beforeLoad: async ({ params }) => {
    await ensureDeveloperEnabled();
    useUiStore.getState().setSelectedWorkspaceId(params.id, 'system');
    throw redirect({ to: '/developer', replace: true });
  },
});
